
<!-- Группа -->

<template>

	<b-overlay :show="wait" v-if="data" class="d-flex h-100" style="flex: 1;gap: 1rem;">

		<div class="main-container_content">

			<filters v-if="active_step == 'filters'" class="mt-2" :id="id" :data="data" v-on:need_refresh="refresh"/>
			
			<structure v-if="active_step == 'structure'" :id="id" :data="data" :full_name="full_name"/>

		</div>

		<steps ref="steps" :steps_items="steps_items" v-on:set_active_step="set_active_step" />
		
	</b-overlay>

</template>

<script>

import api from "../../../api"
import main_tree from "../../../api/main_tree"
import structure from "./structure"
import filters from "./filters"
import steps from "../../widgets/steps"

export default
{
	components :
	{
		structure,
		filters,
		steps,
	},

	data()
	{
		return {

			id : null,
			service : "cadastral_groups",
			stat : null,
			data : { children_tree : {} },
			full_name : "",
			has_children : false,
			has_cost_evaluation : false,
			is_parcel : null,

			ready : false,
			wait : false,

			active_step : null,

			steps_items : [
				{
					id : "filters",
					title : "Правила группировки"
				},
				{
					id : "structure",
					title : "Структура группы"
				},				
			]
    
		}
	},

	created() 
	{
		this.id = this.$route.params.id
		this.active_step = this.$route.params.type || "filters"


		this.refresh()
	},

	mounted()
	{
		this.$refs.steps.set_active_step({id : this.active_step})
	},

	methods :
	{
		set_active_step(id)
		{
			this.active_step = id
			this.$router.push({ name : "group", params : { id : this.id, type : id } }).catch((e) => {if (e.type != 2) console.error(e)})
		},

		refresh()
		{
			// this.wait = true

			return api.call(this, this.service, "get", { id : this.id },
				response =>
				{
					this.data = response.data
					this.has_children = ( this.data.children_tree.children.length != 0 )
					this.has_cost_evaluation = ( this.data.cost_evaluation_comparative != null || this.data.cost_evaluation_expensive != null || this.data.cost_evaluation_profitable != null )
					// this.has_cost_evaluation = this.data.cost_evaluation != null
					this.data.not_editable = this.$root.not_editable //TODO
				})
			.then(api.call(this, this.service, "get_full_name", { id : this.id },
				response =>
				{
					this.full_name = response.full_name
					this.is_parcel = this.full_name.includes("Земельные участки")
				}))
			.then(
				() =>
				{
					this.wait = false
					this.ready = true
				})
			.then(
				() =>
				{
					if(this.$route.query.condition_tab)
					{
						const tab_ind = this.$refs.tabs.tabs.findIndex(tab => tab.title == "Условия группировки")

						if(tab_ind >= 0)
							this.$refs.tabs.currentTab = tab_ind
					}
				})
			.then(this.expand)
		},

		expand(with_children = false)
		{
			//this.$root.$children[0].update()

			api.expand_node_in_tree(this.$root.$children[0].$refs.main_tree, { id : this.id }, with_children)
		},

		go_back()
		{
			api.back.go(this)
		},

		add_child_group()
		{
			this.$refs.add_child_group.execute()
		},

		rename_group()
		{
			this.$refs.rename.execute(this.data.name)
		},

		delete_group()
		{
			this.$bvModal.msgBoxConfirm(
				"Вы действительно хотите удалить группу?",
				{
					title : "Подтверждение удаления",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
						{
							this.wait = true

							api.call(this, this.service, "delete", { id : this.id }, () => main_tree.create(this).then(
								() => this.$router.push("/groups/" + this.data.parent_id + "/filters")
							))
								.then(() => { this.wait = false })
						}
					})
		},

		set_cost()
		{
			this.$refs.set_cost.execute()
		},

		setup_cost_evaluation()
		{
			this.$router.push("/cost_evaluations/" + this.group_node.data.group_id + "/comparative")
		},

		add_cost_evaluation()
		{
			this.$refs.add_cost_evaluation.execute()
		},

		import_model_from_xml()
		{
			this.$refs.import_model_from_xml.execute()
		},

		set_group_auto()
		{
			api.call_long_operation(this, `Группировка в группе ${this.group_node.data.full_name}`, "cadastral", "set_group_auto_many_both_cadastral_object_and_analogue", { query : { "current_version.group" : this.group_node.data.group_id } }, () => main_tree.create(this))
		},
	}
}

</script>

<style>

/* .group_content .tab-content
{
	overflow-y: auto;
	overflow-x: hidden;
} */

</style>

